
import Vue from 'vue/dist/vue.js';

(function (Vue) {
    'use strict';

    var LOCK_CLASS = 'ie-lock';

    window.App.Modal = window.App.Modal || {};

    window.App.Modal = function (modalOptions) {
        var options = modalOptions || {};
        this.modalTemplate = document.getElementById('super_modal_template');

        this.container = document.createElement('div');
        document.body.appendChild(this.container);

        return new Vue({
            el: this.container,
            template: this.modalTemplate,
            data: function () {
                return {
                    isLoading: false,
                    content: null,
                    showClose: true,
                    options: options,
                    title: null,
                    closePromise: null
                };
            },
            computed: {
                isVisible: function () {
                    return this.content !== null;
                },
                isSmall: function () {
                    return options.hasOwnProperty('isSmall') ? options.hasOwnProperty('isSmall') : false;
                },
                isBig: function () {
                    return options.hasOwnProperty('isBig') ? options.hasOwnProperty('isBig') : false;
                },
                isRounded: function () {
                    return options.hasOwnProperty('isRounded') ? options.hasOwnProperty('isRounded') : false;
                },
                // Use this to include your custom class for css purposes:
                customClass: function () {
                    return options.hasOwnProperty('customClass') ? options.customClass : '';
                }
            },
            methods: {
                /**
                 * Insert html in content and return it
                 * @param {String} html
                 * @param {Boolean} showClose
                 * @param {String} title
                 * @return {Promise}
                 */
                insert: function (html, showClose, title) {
                    var self = this,
                        couldClose = typeof showClose === 'boolean' ? showClose : true;

                    this.setTitle(title);
                    this.checkCloseButton(couldClose);
                    this.content = html;

                    // Wait until DOM update and return a promise with content loaded
                    return this.$nextTick()
                        .then(function () {
                            self.hideLoading();
                            return Promise.resolve(self.$refs.content);
                        });
                },
                /**
                 * Check title
                 * @param {String} title
                 */
                setTitle: function (title) {
                    if (typeof title === 'string') {
                        this.title = title;
                    } else {
                        this.title = null;
                    }
                },
                /**
                 * Check close button param
                 * @param {*} showClose
                 */
                checkCloseButton: function (showClose) {
                    this.showClose = !!showClose;
                },
                showLoading: function () {
                    this.isLoading = true;
                },
                hideLoading: function () {
                    var self = this;
                    this.isLoading = false;

                    return this.$nextTick()
                        .then(function () {
                            return Promise.resolve(self.$refs.content);
                        });
                },
                closeCallback: function (callback) {
                    this.closePromise = callback;
                },

                /**
                 * Remove content
                 */
                remove: function () {
                    this.insert(null, true);
                    if (typeof this.closePromise === 'function') {
                        this.closePromise();
                    }
                }
            },
            watch: {
                content: function () {
                    if (this.content !== null) {
                        this.isLoading = false;
                    }
                },
                isVisible: function () {
                    if (this.isVisible) {
                        document.documentElement.classList.add(LOCK_CLASS);
                        if (document.getElementById('multiCheck')) {
                            document.getElementById('user_conditions').setAttribute('id', 'open_modal');
                        }
                    } else {
                        document.documentElement.classList.remove(LOCK_CLASS);
                        if (document.getElementById('open_modal')) {
                            document.getElementById('open_modal').setAttribute('id', 'user_conditions');
                        }
                    }
                }
            }
        });
    };

}(Vue));
